export default {
  disclaimer: '免責聲明',
  privacy: '私隱政策',
  usage: '使用守則',
  dis:[
    "{0}（HKLII）是{1}的研究項目，本中心是由香港大學{2}和香港大學{3}共同建立的，並得到 {4}（AustLII）的協助，而 AustLII 是由{5}和{6}聯合營運（主辦大學）。",
    "「HKLII 資料提供者」包括但不限於香港特別行政區的司法機構，香港特別行政區律政司、香港國際仲裁中心和香港大學。",
    "HKLII 是提供免費服務，而 HKLII 提供的所有資訊均可於其他來源取得。",
    "HKLII、主辦大學或 HKLII 資料提供者均不建議使用者依賴 HKLII 所提供之資訊。HKLII 對 HKLII 所提供之資訊、用途以及使用上述資訊而引致的法律後果概不負責。",
    "HKLII、主辦大學或 HKLII 資料提供者均不保證、承諾或擔保 HKLII 所提供資料為準確、完整或最新。如用戶將有關資料用作重要用途，應先從其他來源核實有關資料。如用戶需法律參考材料的正式版本，應參考有關官方刊物。",
    "HKLII 上的超文本鏈接均由 HKLII 而非由資料提供者所建立。HKLII 上的超文本鏈接是通過程式以自動方式建立，故並非所有鏈接均全面及準確。HKLII、主辦大學或 HKLII 資料提供者就超文本鏈接的準確性，全面性或其他任何方面均不作任何保證、承諾或擔保。一般而言，超文本鏈接僅為各資料提供互連。"
  ],
  austlii: 'Australasian Legal Information Institute',
  unsw: '新南威爾士大學',
  uts: '悉尼科技大學',
  pp: [
    "HKLII 的隱私政策是根據保護資料私隱的國際標準制定。",
    "HKLII將收集訪問 HKLII 頁面用家的網絡身份。 有關資料將用於網絡分析、使用情況分析以及對使用模式的研究，從而改善HKLII的服務。只有HKLII的管理及研究人員才能夠取得及使用有關資料，該些人員亦必須遵守此私隱政策。",
    "HKLII 不會在未經許可的情兄下透露或發佈任何足以辨識個別機器或可能辨識地址子組別的資料，惟HKLII會發布有關用家使用模式的匯總資料。",
    "HKLII 保留收集更廣泛信息的權利，包括(i)任何嘗試訪問 HKLII 而引致的安全問題（並在必要時向相關部門披露）；及 (ii)不定期進行網絡分析。",
    "HKLII 的某些資料庫包含個人資料，包括法院和審裁處的判決。HKLII 是有關公共機構的同意下發佈這些資料庫，而有關公共機構有責任在遵守其運作的法律要求的情況下，在資料傳播方面平衡個人隱私和公共利益。如有需要對個人資料進行匿名處理，有關工作則由則由相關的公共機構負責。 HKLII 不會亦無法審查任何由有關公共機構提供的資訊。",
    "HKLII 並不同意其他網站將這些資料庫的內容編入索引。HKLII 試圖通過將這些資料庫置於符合自願機器人排除標準的「網絡爬蟲」、「網絡機械人」及「網絡蜘蛛」的允許範圍之外來防止此類索引的發生。在某些情況下，HKLII 會為其他法律網站對 HKLII 資料庫進行索引作例外處理。",
    "HKLII 還會監察是否有任何網絡機械人在違反此政策的情況下，嘗試對這些資料庫建立索引，一經發現將採取措施禁止其訪問 HKLII 網站。",
    "HKLII 保留禁止任何明顯違反此等法律要求的用戶或網站訪問其資料庫的權利。",
    "如你對此政策有任何意見或建議，歡迎向我們提出{0}。"
  ],
  pp_a: "A. 有關 HKLII 的使用資訊",
  pp_b: "B. HKLII 資料庫中包含的個人資料",
  pp_feedback: "意見",
  up_title: "有關 HKLII 文件的使用守則",
  up_1: "1.  一般原則",
  up_2: "2. 最終用戶",
  up_3: "3. HKLII 內容的版權",
  up_4: "4. 其他商業及非商業系統使用HKLII資料",
  up_5: "5. 法院和其他資料提供者提供的原始文件",
  up:[
    "HKLII 是非牟利的發佈者，它為個人最終用戶提供免費資訊，讓公眾能閱讀、列印和複製有關資料作個人用途及其他版權法下允許的用途。",
    "為提供這項服務，HKLII 與文件的來源和文件的版權持有人達成協議，或在版權持有人的許可下，建立了一套一手和二手法律資訊（包括案例、條例、條約和法律改革文件）的集合。",
    "HKLII 不是資料存儲庫，因為它不為其他發佈者提供從 HKLII 獲取文件進行重新發布的服務。其他發佈者需要從其原始來源或通過其他適當的授權途徑獲得這些文件。",
    "對於 HKLII 發布的所有文件，HKLII 不允許任何人重新發佈由 HKLII 添加到文檔中的增值內容（包括超文本標記和替代引文）。此限制並不包括 HKLII 使用引述案例通用編號 (Neutral Citations)（不論是否由 HKLII 增設）。",
    "HKLII 對複製和使用案例文件加設了限制。HKLII 阻截所有網路蜘蛛和其他自動化代理程式通過機器人排除標準訪問案例文件。HKLII 的政策與國際上所有類似組織相同。這項政策的原因包括：",
    "HKLII 系統的個人最終用戶可根據版權法自由訪問，複製和列印作個人用途的資料；",
    "案例的使用受上述(1)(e)條約束。",
    "HKLII 並不擁有其發佈的原始文件的版權，故不能授權其他人複製這些原始文件。",
    "HKLII 持有其添加到原始文件中的所有增值內容（包括超文本標記和替代引文）之版權。HKLII 一般會應使用者的要求允許複製有關內容作教學、培訓或相關用途。",
    "HKLII 不會將其由其他來源取得之原始文件存儲或提供予其他發佈者重新發佈。此政策適用於文檔的主動搜集，以及通過網路蜘蛛或其他自動收集程式進行的被動搜集。如果上述網路蜘蛛或其他程式自動收集行為明顯可見，HKLII 系統將作出攔截。",
    "在一些情況下，HKLII 會與其他發佈者協商協議，將 HKLII 頁面加為其服務的一部分，包括協助他們鏈接正確的 HKLII 頁面。",
    "HKLII 支持法院和其他公共法律資訊提供者向大眾提供法律資訊（如案例、法律條文等），而他們有責任(i)持續提供資料予各發佈者及(ii)保留已提供的資料的副本。",
    "HKLII 將應有關要求就 (a)(ii) 項所述協助法院或其他公共法律資訊提供者。",
    "各級法院或其他公共法律資訊提供者都就有關隱私（包括通過第三方搜尋引擎訪問）、 「撤銷」或替換判決，以及第三方重新發佈資料（包括版權政策）等事宜制定各自的政策。",
    "HKLII 遵守各級法院或其他公共法律資訊提供者的政策，並支持制定有關此類政策的標準。",
    "HKLII 可酌情修改此政策。",
  ],
  up_1e: [
    "HKLII 必須遵守法院和當事人的移除、匿名和其他修改要求；",
    "HKLII 必須遵守資料提供者訂下的許可條件；和",
    "HKLII 必須平衡個人隱私與開放訪問之間的需求，特別是使用搜尋引擎時。",
  ],
  date: "2011 年 10 月 15 日",
}